<template>
  <div>
    <div :id="klarnaRoodDivId"></div>
    <AppErrorText v-if="showLoadErrorMessage">
      Kunde inte ladda in det här betalsättet för Klarna. Vänligen välj ett
      annat, prova att ladda om sidan, eller kontakta vår kundsupport.
    </AppErrorText>
  </div>
</template>

<script lang="ts" setup>
import { useKlarna } from '~/composables/checkout/useKlarna';

const { loadKlarna } = useKlarna();

interface Props {
  klarnaRoodDivId: string;
  klarnaCategoryIdentifier?: string;
}

const props = defineProps<Props>();

const showLoadErrorMessage = ref(false);

// (july 2025)
// Force the little Klarna iframe to set dark theme if the rest of the app
// has it, otherwise the light theme, ignoring the user's preferred setting for now.
// When the rest of the app follows the user's preferred setting, this can be removed.
const forceKlarnaIframeTheme = () => {
  const klarnaRootElement = document.getElementById(props.klarnaRoodDivId);

  if (klarnaRootElement) {
    const bodyHasDarkClass = document.body.classList.contains('dark');
    const klarnaIframeThemeToSet = bodyHasDarkClass ? 'dark' : 'light';

    const osmShadowHostEl = klarnaRootElement.querySelector('#osm_shadow_host');
    const osmContainerEl = klarnaRootElement.querySelector('#osm_container');

    if (osmShadowHostEl && osmShadowHostEl.getAttribute('data-theme')) {
      osmShadowHostEl.setAttribute('data-theme', klarnaIframeThemeToSet);
    }

    if (osmContainerEl && osmContainerEl.getAttribute('data-theme')) {
      osmContainerEl.setAttribute('data-theme', klarnaIframeThemeToSet);
    }
  }
};

onMounted(async () => {
  if (!import.meta.client) {
    return;
  }

  await nextTick();

  loadKlarna(props.klarnaRoodDivId, props.klarnaCategoryIdentifier, (res) => {
    if (res.show_form === false) {
      showLoadErrorMessage.value = true;
    } else {
      forceKlarnaIframeTheme();
    }
  });
});
</script>
